import { InventoryAllocationFormData } from './types';

/** Filter options for toolbar (not mock list data). */
export const allocationStatusFilterOptions = [
  { id: 'all', name: 'Tất cả' },
  { id: 'draft', name: 'Nháp' },
  { id: 'approved', name: 'Đã duyệt' },
  { id: 'inactive', name: 'Ngưng sử dụng' },
];

export const createDefaultAllocationForm = (companyId = ''): InventoryAllocationFormData => ({
  code: '',
  name: '',
  order_no: '',
  store_name: '',
  status: 'draft',
  status_color: '',
  qty: '',
  unit_id: '',
  item_id: '',
  company_id: companyId,
  note: '',
  lines: [],
});
